<template>
  <div class="auth-wrapper auth-v2">

    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">
          Tinh hoa Thần số học
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Tinh hoa thần số học"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            Xin chào!
          </b-card-title>
          <b-card-text class="mb-2">
            Vui lòng đăng nhập
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="Điện thoại / Tên đăng nhập"
                label-for="dien-thoai-login"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Điện thoại / Tên đăng nhập"
                  vid="dien-thoai-login"
                  rules="required"
                >
                  <b-form-input
                    id="login-dien_thoai"
                    v-model="dien_thoai"
                    :state="errors.length > 0 ? false:null"
                    name="Điện thoại / Tên đăng nhập"
                    placeholder="0988554778"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Mật khẩu</label>
                  <b-link :to="{name:'auth-forgot-password'}">
                    <small>Quên mật khẩu?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Mật khẩu"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Mật khẩu"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Đăng nhập
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCardText, BCardTitle, BImg, BForm, BButton, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
// import { getHomeRouteForLoggedInUser } from '@/auth/utils'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import config from '../../../config.json'
//

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      dien_thoai: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          const bodyFormData = new FormData()
          bodyFormData.set('username', this.dien_thoai)
          bodyFormData.set('password', this.password)
          this.$store.state.showBlock = true
          axios.post(`${config.apiUrl.mainUrl}store-api/login`, bodyFormData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
            .then(response => {
              this.$store.state.showBlock = false
              const userLogged = response.data.user
              useJwt.setToken(response.data.user.auth_key)
              useJwt.setRefreshToken(response.data.user.auth_key)
              Object.assign(userLogged, {
                doanh_so: response.data.doanh_so,
                tien_dau_tu: response.data.tien_dau_tu,
                so_bai: response.data.user.so_lan_xem_con_lai,
                ability: [
                  {
                    action: 'manage',
                    subject: 'all',
                  },
                ],
              })
              localStorage.setItem('userData', JSON.stringify(userLogged))
              this.$ability.update([
                {
                  action: 'manage',
                  subject: 'all',
                },
              ])
              this.$router.replace('/')
                .then(() => {
                  this.showToast('success', `Chào mừng ${response.data.user.hoten} đăng nhập thành công`, 'BellIcon', 'Bạn đã đăng nhập thành công!')
                })
                .catch(error => {
                  this.$refs.loginForm.setErrors(error.response.data.error)
                })
            }).catch(e => {
              this.$store.state.showBlock = false
              this.showToast('danger', 'Thông báo', 'BellIcon', e)

            // if (typeof e.response !== 'undefined') {
            // } else if (typeof e.message !== 'undefined') {
            //   this.showToast('danger', 'Thông báo', 'BellIcon', e.message)
            // } else {
            //   this.showToast('danger', 'Thông báo', 'BellIcon', e)
            // }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/pages/page-auth.scss';
</style>
